import { render } from "./Properties.vue?vue&type=template&id=076c5c96&ts=true"
import script from "./Properties.vue?vue&type=script&lang=ts"
export * from "./Properties.vue?vue&type=script&lang=ts"

import "./Properties.vue?vue&type=style&index=0&id=076c5c96&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__